import { request } from '../client';
import { endpoints } from '../endpoints';
import { asList } from './shape';

export const listCategories = async (opts) => asList(await request(endpoints.categories.all(), opts));
// The current backend wraps this one list in an object: { countries: [...] }
export const listCountries = async (opts) => asList(await request(endpoints.geo.countries(), opts), 'countries');
export const listStates = async (countryId, opts) => asList(await request(endpoints.geo.states(countryId), opts));
// A state can have hundreds of cities (up to ~600 rows, 160 KB), so allow more time than the default.
export const listCities = async (countryId, stateId, opts) =>
  asList(await request(endpoints.geo.cities(countryId, stateId), { timeoutMs: 45000, ...opts }));
// Returns every category WITH its questions and answers embedded (about 165 KB, a few seconds), so one call serves the whole picker.
export const listProfilingCategories = async (opts) =>
  asList(await request(endpoints.profiling.categories(), { timeoutMs: 45000, ...opts }));

/**
 * Rate card lookup. The current backend returns a single number which is a
 * PERCENTAGE from the rate card, not a currency amount (see src/api/README.md).
 */
export const getRateCardPercentage = async (ir, loi, opts) => {
  const v = await request(endpoints.rateCard.price(), { ...opts, query: { ir, loi } });
  return typeof v === 'number' ? v : null;
};
